<template>
    <div v-if="error.message" class="grid ls-error">
        <div class="grid__col-12">
            <div class="ls-error__container">
                <p class="ls-align--center ls-error__message">
                    <slot></slot>
                    <span v-if="!$slots.default">
                        <span v-if="error.field_messages.email">
                            {{ error.message }}
                            To login, visit
                            <a
                                v-ls-track.click="{
                                    target: 'my-login-duplicate-email--link',
                                }"
                                class="ls-color--blue"
                                :href="url"
                                >my.{{ domain }}
                            </a>
                        </span>
                        <span v-else-if="error.code === 2">
                            This order has already been booked. To login, visit
                            <a
                                v-ls-track.click="{
                                    target: 'my-login-order-processed--link',
                                }"
                                class="ls-color--blue"
                                :href="url"
                                >my.{{ domain }}
                            </a>
                        </span>
                        <span v-else-if="error.message">
                            {{ error.message }}
                        </span>
                        <span v-else-if="address.showStandaloneStreetNumber">
                            Oops! Google was unable to find the exact street number of your address.
                        </span>
                    </span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import * as types from '@/store/types';
import brandMixin from '@/mixins/brand.mixin';

export default {
    mixins: [brandMixin],
    computed: {
        ...mapState(['address', 'error']),
        url() {
            return process.env.VUE_APP_CUSTOMER_BASE_URL;
        },
    },
    destroyed() {
        this.errorClearError();
    },
    methods: {
        ...mapActions({
            errorClearError: types.ERROR__CLEAR_ERROR,
        }),
    },
};
</script>

<style lang="scss" scoped>
.ls-error {
    margin-top: rem(-3);
}

.ls-error__message {
    > * {
        display: block;
        &:not(:first-child) {
            margin-top: rem(-4);
        }
    }
}

.ls-error__container {
    color: palette(red);
    background-color: palette(red, xx-light);
    border: 1px solid palette(red, light);
    border-radius: 3px;
    padding: rem(-4);
}

.themed-app {
    .ls-error__container {
        color: $theme-color-danger-dark;
        background-color: $theme-color-danger-light;
        border-color: $theme-color-danger-dark;
    }
}
</style>
